<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            FERNANDO GARREAUD Y EL <br>
            ÁLBUM REPÚBLICA PERUANA 1900:<br>
            
        </p>
        <p class="fontMS500 colorPrincipal font-26">LA PERSISTENCIA DE LA MEMORIA </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio34/fernando-garreaud">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio34/fernando-garreaud">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio34/fernando-garreaud">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio34/FERNANDOG-000.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    LA GUERRA DEL PACÍFICO FUE, SIN DUDA, UN PERÍODO TRAUMÁTICO EN LA HISTORIA 
                    PERUANA. SIN EMBARGO, ALGUNAS DÉCADAS DESPUÉS, COMO SEÑALAN NATALIA MAJLUF Y 
                    LUIS EDUARDO WUFFARDEN, <strong>«NUEVOS AIRES DE OPTIMISMO ABRIERON PASO A 
                    PLANTEAMIENTOS NACIONALISTAS QUE IMPULSABAN LA TRANSFORMACIÓN DEL PAÍS».</strong>
                    <br><br>
                    EN UN CONTEXTO DE DISCIPLINA FISCAL Y BONANZA ECONÓMICA, A PARTIR DE 1898, Y 
                    GRACIAS AL APOYO DEL PRESIDENTE NICOLÁS DE PIÉROLA, FERNANDO GARREAUD, UN 
                    AFAMADO FOTÓGRAFO FRANCÉS RADICADO EN EL PERÚ, RECORRIÓ MUCHAS REGIONES DEL 
                    PAÍS PARA REGISTRAR ALGUNOS ASPECTOS DE SU PRODUCCIÓN AGRÍCOLA, MINERA E 
                    INDUSTRIAL, RESTOS ARQUEOLÓGICOS, ARQUITECTURA, ETNOGRAFÍA, ENTRE OTROS, LO QUE 
                    SIGNIFICÓ UNA REPRESENTACIÓN AMPLIA Y DIVERSA DEL PERÚ.
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-001.png">
                        </a>
                        <p class="text-center fontMS100Italic font-18">
                            <br>
                            Lima. Monumento conmemorativo de la batalla del Dos de Mayo de
                            1866. Pagina 5. Disponible en: <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #000000;">Biblioteca Digital</a> 
                            <br>
                        </p>
                    </div>
                    
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>
                <p class="fontMS100 text-justify font-24">
                    El resultado de esta empresa fue el álbum República peruana 1900, planificado por el Estado 
                    peruano para ser exhibido en la Exposición Universal de París de 1900 que, a decir de especialistas, 
                    se presentó como el «primer esfuerzo por construir la imagen oficial del país, integrando 
                    visualmente los diferentes escenarios y habitantes costeños, serranos y selváticos contenidos en el 
                    territorio, en un contexto marcado por los discursos de regeneración nacional posbélica y de 
                    progreso material».
                    <br><br>
                    Debido a la importancia de este álbum, preservado en la Biblioteca Nacional del Perú, se ofrece este 
                    Micrositio para conocer la trayectoria artística de Fernando Garreaud y, fundamentalmente, revisar 
                    las imágenes que han construido a la (re)creación y a la persistencia de la memoria iconográfica del 
                    Perú.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            FERNANDO GARREAUD
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-7">
                        <p class="fontMS100 text-justify text-white font-22">
                            <br><br>
                            FERNANDO GARREAUD (CHILE, 1870-BUENOS AIRES, 1929) 
                            FUE HIJO DEL FOTÓGRAFO FRANCÉS EMILIO GARREAUD Y DE 
                            MARÍA CRISTINA FERRIER LEBLANC.
                            <br><br>
                            LUEGO DE RESIDIR EN CHILE HASTA LA MUERTE DE SU PADRE, 
                            Y ANTES DE LA GUERRA DEL PACÍFICO, VIAJA AL PERÚ Y ABRE 
                            SU ESTUDIO FOTOGRÁFICO EN LIMA (JR. DE LA UNIÓN).
                            <br><br>
                            EN ESTE PAÍS, GRACIAS A SU MADRE, AMIGA DE NICOLÁS DE 
                            PIÉROLA, GARREAUD OBTUVO UN DECIDIDO APOYO OFICIAL.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify text-white font-18">
                            En base a ese apoyo gubernamental, y utilizando el material documental 
                            elaborado por los fotógrafos Charles Kroehle, entre 1898 y 1899, Garreaud 
                            recorrió las diversas regiones del país para registrar sus poblaciones y 
                            zonas urbanas y rurales.
                            <br><br>
                            El resultado de ese esfuerzo fue el álbum República peruana 1900 que fue 
                            enviado a la Exposición Universal de París de ese año. Ese álbum es un 
                            inventario de riquezas naturales, monumentos y actividades productivas 
                            que muestran el progreso material peruana de ese tiempo. Dicho álbum 
                            mereció la medalla de bronce de la Exposición.
                            <br><br>
                            A inicios del siglo XX, su estudio se convirtió en uno de los más reconocidos 
                            de Lima. Posteriormente, radicó en Estados Unidos, Chile y Buenos Aires 
                            donde, en 1920, fallece al parecer solo y totalmente arruinado.
                        </p>
                    </div>
                    
                    <div class="col-sm-5" >
                        <br><br><br>
                        <div class="col-sm-12" >
                            <a href="https://hdl.handle.net/20.500.14428/55842" target="_blank">
                                <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-002.png">
                            </a>
                            <p class="text-center text-white font-12" style="background: #000000" >
                                <br><br>
                                [Retrato de Fernando Garreaud]. Adolph Dubreuil. 1897.<br>
                                1 negativo sobre placa de vidrio : gelatino bromuro ; 24 x 18 cm. <br>
                                Disponible en: <a href="https://hdl.handle.net/20.500.14428/55842" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                                <br><br><br>
                            </p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="w-90 text-center mt-5 ml-auto mr-auto">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                    <a style="color: inherit; display: block; height: 100%; position: relative;">
                        <img src="{{ slide.img }}" alt="" class="w-100">
                        <div class="overlay">
                            <p class="text-overlay">
                                <span class="fontMS100Italic">{{slide.autor}}</span><br>
                                <span class="fontMS100Italic">{{slide.titulo}}</span><br>
                            </p>
                        </div>
                    </a>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «UN NUEVO PERÍODO DE AUGE SE INICIABA PARA LA FOTOGRAFÍA EN LA DÉCADA DE 1890, CUANDO EL PAÍS EMPEZABA A 
                                RECONSTRUIRSE TRAS EL DESASTRE ECONÓMICO, POLÍTICO Y SOCIAL QUE SIGNIFICÓ LA GUERRA DEL PACÍFICO. (…) 
                                MIENTRAS LAS VISTAS URBANAS Y RURALES PRODUCIDAS EN EL PERÍODO ANTERIOR A LA GUERRA DEL PACÍFICO HABÍAN 
                                PRESENTADO UN PERFIL VOLUNTARISTA DE LA NACIÓN EN SU MARCHA HACIA EL PROGRESO, SURGIRÍA UNA VISIÓN MÁS 
                                ABARCADORA DEL PAÍS EN LA OBRA DE FOTÓGRAFOS COMO CHARLES KROEHLE, FERNANDO GARREAUD, LUIS D. GISMONDI 
                                Y MAX T. VARGAS».<br><br>
                                («EL PRIMER SIGLO DE LA FOTOGRAFÍA. PERÚ 1842-1942». NATALIA MAJLUF Y LUIS EDUARDO WUFFARDEN. 2001)   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 140%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ÁLBUM REPÚBLICA<br>
                            PERUANA 1900
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                </div>
                <p class="text-center  fontMS500 font-24">
                    <br><br>
                    COMO SE HA SEÑALADO, FERNANDO GARREAUD VIAJÓ POR TODO EL PAÍS E HIZO UN AMPLIO 
                    REGISTRO FOTOGRÁFICO CON EL PROPÓSITO DE DOCUMENTAR LAS PRINCIPALES CIUDADES 
                    DE LA REPÚBLICA. PARA TAL EFECTUÓ LOS SIGUIENTES RECORRIDOS: 
                    <br>
                </p>

                <!-- xxxxxx -->

                <div class="row p-5">
                    <div class="col">
                        <br>
                    </div>
                    <div class="col-sm-12 image-container">
                        <img src="/assets/images/micrositio/micrositio34/FERNANDOG-003.png" alt="Imagen">
                        <ul class="text-overlay2 text-left font font20">
                            <li>LIMA - CALLAO - LA LEGUA - LA PUNTA - CHORRILLOS.</li>
                            <li>LIMA - JUNÍN Y PASCO - SAN MARTÍN - AMAZONAS - CAJAMARCA - SAN MARTÍN - LORETO.</li>
                            <li>AREQUIPA - PUNO – CUSCO – MOQUEGUA - TACNA - ARICA.</li>
                            <li>PIURA - LAMBAYEQUE - CAJAMARCA - LA LIBERTAD - ÁNCASH.</li>
                        </ul>
                    </div>
                    <div class="col">
                        <br>
                    </div>

                    <p class="text-justify  fontMS100 font-24">
                        <br><br>
                        De este registro se conservan fotografías sueltas y dos álbumes completos que contienen 
                        cerca de 500 imágenes del mismo formato. Un ejemplar se encuentra en el Instituto Raúl 
                        Porras Barrenechea, y el otro en la bóveda de la Biblioteca Nacional del Perú. Este último 
                        cuenta con una reproducción en microfilm y una versión digital.
                        <br>
                    </p>

                </div>
                
                <div class="row p-5">



                    <div class="col-sm-6 image-large-container">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                            <img src="/assets/images/micrositio/micrositio34/FERNANDOG-004.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic font-18">
                            <br>
                            Cubierta del álbum República peruana 1900. 1900. 65 x 45 cm. 
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">Biblioteca Digital</a>
                        </p>
                    </div>

                    <div class="col-sm-6 image-grid-container">
                        <div class="image-grid-item ">
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-005.png" alt="Imagen">
                            </a>
                            <p class="fontMS100Italic font-12 background-gray text-white">
                                
                                Lima. Vista general del lado este desde la 
                                torre de San Agustín. No. 2. Página 6. 
                                <br><br>
                            </p>
                        </div>
                        <div class="image-grid-item">
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-006.png" alt="Imagen">
                            </a>
                            <p class="fontMS100Italic font-12 background-gray text-white">
                                
                                Lima. Palacio de Gobierno y Plaza 
                                principal. No. 6. Página 8. 
                                <br><br>
                            </p>
                        </div>
                        <div class="image-grid-item" >
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-007.png" alt="Imagen">
                            </a>
                            <p class="fontMS100Italic font-12 background-gray text-white">
                                
                                Lima. Plaza Bolívar. No. 58.
                                Página 30. 
                                <br><br>
                            </p>
                        </div>
                        <div class="image-grid-item">
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-008.png" alt="Imagen">
                            </a>
                            <p class="fontMS100Italic font-12 background-gray text-white">
                                
                                Lima. Vista exterior del Molino de Santa 
                                Clara. No. 99. Página 48 
                                <br><br>
                            </p>
                        </div>
                    </div>

                </div>

                <div class="row p-5">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-009.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Miraflores. Plaza. No. 133. Página 64. 
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-010.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Estación de San Bartolomé. Llegada 
                                    de los vendedores de frutas. No. 148. 
                                    Página 70. 
                                    <br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-011.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    [La] Oroya. Vista general. No. 219. 
                                    Página 105. 
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-012.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Cerro de Pasco. Vista general. No. 225. 
                                    Página 108. 
                                    <br><br>
                                </p>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="row p-5">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-013.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Casapalca. Laboratorio y cuarto de 
                                    ensayos de Backus y Johnstons. No. 
                                    196. Página 94. 
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-014.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Línea del Callao a La Oroya. Túnel de 
                                    Galera: punto más elevado de la línea 
                                    4700 msnm. Página 98. 
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-015.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Camino al Pichis. Río Pachitea, boca 
                                    de Santa Isabel. No. 257. Página 121. 
                                    <br><br>
                                </p>
                            </div>
                            <div class="col-sm-3">
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-016.png" alt="Imagen">
                                </a>
                                <p class="fontMS100Italic font-12 background-gray text-white">
                                    
                                    Camino al Pichis. Indios Cachimbos 
                                    (antropófagos). No. 268. Página 125. 
                                    <br><br>
                                </p>
                            </div>
                        </div>
                        
                    </div>
                </div>
                    
                
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «A PESAR DE LA VENTAJOSA PROPORCIÓN DE VISTAS DE LIMA —QUE PODÍA LLEGAR A LA MITAD—, EL FUERTE 
                                PROTAGONISMO DEL CUSCO Y EL SUR ANDINO, ASÍ COMO DE ALGUNOS PARAJES AMAZÓNICOS FOTOGRAFIADOS POR 
                                PRIMERA VEZ, CONFIERE AL ÁLBUM SU ATRACTIVO PRINCIPAL. EMPLAZADO POR LO GENERAL EN ALTURAS ESTRATÉGICAS, 
                                GARREAUD COMPONE SUS PANORAMAS CON MARCADAS DIAGONALES PARA ACENTUAR LAS LÍNEAS DE LA PERSPECTIVA, 
                                SEA EN EL TRAZO DE LAS NUEVAS AVENIDAS DE LA CAPITAL, EN LOS TRAMOS DEL FERROCARRIL CENTRAL O DEL SUR, O BIEN 
                                EN LAS PLANTACIONES DE LA COSTA O LOS RÍOS NAVEGABLES DE LA SELVA».<br><br>
                                («El primer siglo de la fotografía. Perú 1842-1942». Natalia Majluf y Luis Eduardo Wuffarden. 2001)    
                                <br><br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            VIAJE AL SUR
                            
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                </div>

                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-center fontMS500 font-24">
                            SI BIEN LA INTEGRACIÓN DE LIMA CON EL RESTO DEL PAÍS HABÍA SIDO FRAGMENTADA Y 
                            DISCONTINUA, LA IDEOLOGÍA CIENTÍFICO POSITIVISTA DE FINES DEL SIGLO XIX IMPULSÓ DESDE 
                            EL ESTADO LA MEJORA DE LAS CONDICIONES SANITARIAS DE LA POBLACIÓN CON EL 
                            DESARROLLO DE VARIAS CAMPAÑAS QUE TUVIERON COMO OBJETIVO LA DISMINUCIÓN DE LA 
                            MORTALIDAD. COMO RESULTADO, EL PERÚ INICIÓ LA PRIMERA FASE DE SU CRECIMIENTO 
                            DEMOGRÁFICO, SOBRE TODO EN CIUDADES COMO LIMA, AREQUIPA, CUSCO Y TRUJILLO.
                        </p>
                        <p class="text-justify  font-24">
                            <br>
                            En ese contexto, en su recorrido por el sur, que comprendió Arequipa, Puno, Cuzco, Moquegua, 
                            Tacna y Arica, Garreaud puso en evidencia «aspectos de la producción agrícola, minera e industrial, 
                            así como en las modernas instituciones de la república» e «iba acompañado por un amplio registro 
                            etnográfico, [arquitectónico] y arqueológico, con el cual retornaba la imagen del país antiguo y 
                            exótico que había fascinado a viajeros y exploradores a lo largo del siglo XIX» (Majluf y Wuffarden).
                            <br><br>
                            De esta manera, Garreaud registró el puerto de Arica, las fábricas de maestranza del Ferrocarril del 
                            Sur, el Convento de Santa Catalina, los mercados altiplánicos, los viajes en el Lago Titicaca, las ruinas 
                            arqueológicas de Pisac, Ollantaytambo y Sacsahuáman, las iglesias cusqueñas, las calles de Pasco, los 
                            procesos mineros y algunas imágenes de hombres y mujeres en diversas labores.
                            <br><br>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-3">
                        <p style="line-height: 400%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            AREQUIPA
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-003.png">
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-004.png">
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-017.png">
                        </a>
                        
                        <p class="text-center fontMS100Italic font-15">
                            <br>
                            Vista general de Arequipa. No. 275. Página 128.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <p class="text-justify fontMS500 font-24">
                        <br>
                        LA OBRA DE FERNANDO GARREAUD PUEDE CONSIDERARSE COMO UNO DE LOS MÁS VALIOSOS 
                        DOCUMENTOS GRÁFICOS PARA LA HISTORIA DEL PERÚ EN LA MEDIDA QUE REGISTRÓ, EN EL 
                        CASO DE AREQUIPA, IMÁGENES DE PAISAJES, ARQUITECTURA (PLAZA PRINCIPAL, CATEDRAL, 
                        PUENTE PIEDRA), CIENCIA Y TECNOLOGÍA. 
                        <br><br>
                    </p>
                    <p class="text-justify fontMS100 font-24">
                        <br>
                        Estas imágenes reflejan el interés de Garreaud por difundir los avances tecnológicos, arqueológicos 
                        y antropológicos del país, los que confluyen «con el surgimiento de formas de nacionalismo que 
                        daban primacía ya no a los proyectos políticos sino a la etnografía sino a las formas culturales 
                        autóctonas». 
                        <br><br>
                    </p>
                </div>
                <div class="row p2">
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-018.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Camino al Pichis. Río Pachitea, boca 
                            de Santa Isabel. No. 257. Página 120.                
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-019.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Arequipa. Catedral. No. 280. 
                            Página 130.               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-020.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Arequipa. Gran telescopio de 24 
                            pulgadas de diámetro del Observatorio 
                            Astronómico. No. 295. Página 132.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-021.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Arequipa. Vista de los hilares de la 
                            fábrica del Huaico. No. 290. Página 134.               
                            <br><br>
                        </p>
                    </div>
                </div>
                

                <div class="row">
                    <div class="col-sm-6" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-026.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 "  >
                            <br>
                            Arequipa. Estatua del Trabajo (alegoría de yeso). No. 277. Página 128. Disponible en: 
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">Biblioteca Digital</a>            
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-022.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Arequipa. Factoría de los ferrocarriles: 
                            locomotora No. 24 construida en la 
                            maestranza. No. 299. Página 136.               
                            <br>
                        </p>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-024.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Arequipa. Puente Piedra. No. 276. 
                            Página 128.              
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-023.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Mollendo. Calle del Comercio. No. 273. 
                            Página 126.
                            <br><br><br>
                        </p>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-025.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Vista de Mollendo tomada desde el 
                            faro. No. 274. Página 126.
                            <br>
                        </p>
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «NO BASTABA QUE EN AQUEL GRANDIOSO CERTAMEN UNIVERSAL, SÍNTESIS Y RESUMEN DE LOS PROGRESOS DEL SIGLO 
                                DECIMONONO, ESTUVIERA REPRESENTADO EL PERÚ TAN SOLO POR SUS PRODUCTOS NATURALES E INDUSTRIALES, QUE 
                                PODRÁN DAR UNA IDEA DE LA RIQUEZA Y FECUNDIDAD DE SU PRIVILEGIADO SUELO; SINO QUE TAMBIÉN ERA PRECISO QUE 
                                ESTUVIERA POR SUS PRODUCCIONES INTELECTUALES, LAS QUE, A LA VEZ DE QUE DARÁN UNA IDEA CABAL Y AMPLIA EN EL 
                                EXTRANJERO DEL ESTADO FLORECIENTE DE LAS LETRAS EN LA REPÚBLICA, SERÁN TIMBRE DE HONOR Y DE GLORIA PARA UN 
                                PAÍS TAN JOVEN, Y QUE A PESAR DE SU AGITADA VIDA POLÍTICA Y ESCASO TIEMPO DE EDUCACIÓN, HA LLEGADO A 
                                COLOCARSE EN ESTE TERRENO, A LA ALTURA DE LAS MÁS CIVILIZADAS NACIONES DEL MUNDO». <br><br><br>
                                (Carlos Prince, comisionado para formar la Biblioteca Peruana en la Exposición Universal de París. 1900)  
                                <br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-3">
                        <p style="line-height: 300%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            PUNO
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-003.png">
                    </div>
                    <div class="col-sm-3"></div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-004.png">
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-027.png">
                        </a>
                        
                        <p class="text-center fontMS100Italic font-15">
                            <br>
                            Lago Titicaca: balsas de cañas hechas por los naturales del país. No. 308. 
                            Página 140.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <p class="text-justify fontMS500 font-24">
                        <br>
                        EN ESTE PROCESO DE ELABORACIÓN DE UN DISCURSO DE REGENERACIÓN Y MODERNIZACIÓN 
                        NACIONAL LUEGO DE LA GUERRA DEL PACÍFICO, GARREAUD MOSTRÓ ASPECTOS 
                        ARQUITECTÓNICOS DE LA CIUDAD DE PUNO Y ASPECTOS ETNOGRÁFICOS DE LOS HABITANTES 
                        DEL LAGO TITICACA. 
                        <br><br>
                    </p>
                </div>

                <div class="row">
                    <div class="col-sm-6" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-028.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 "  >
                            <br>
                            Arequipa. Estatua del Trabajo (alegoría de yeso). No. 277. Página 128. Disponible en: 
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #000000;">Biblioteca Digital</a>            
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-029.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Puno. Arco Deustua. No. 302. 
                            Página 138.               
                            <br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-031.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Lago Titicaca: isla donde nació Manco 
                            Cápac. No. 313. Página 142.              
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-030.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Puno. Colegio de San Carlos. 
                            No. 304. Página 138.
                            <br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-032.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Lago Titicaca: llegada en balsas de los 
                            naturales para el mercado. No. 310. 
                            Página 141.
                            <br><br>
                        </p>
                    </div>
                    
                </div>

                <div class="row ">
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-033.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Lago Titicaca: a 12666 pies sobre el 
                            nivel del mar. No. 305. Página 140.                
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-034.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Lago Titicaca: internacional en el 
                            origen del Desaguadero. No. 306. 
                            Página 140.               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-035.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Lago Titicaca. Chililaya: primer 
                            puerto boliviano y aduana. No. 315. 
                            Página 143.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-036.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Puente entre Puno y Sicuani (400 
                            pies de largo sobre 10 de ancho). 
                            No. 316. Página 142.               
                            <br><br>
                        </p>
                    </div>
                </div>
                



            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <span>
                                <br><br>
                                «GARREAUD MANTIENE SIEMPRE UNA DISTANCIA QUE BUSCA HACER OBJETIVA FRENTE A AQUELLO FOTOGRAFIADO. DE AHÍ 
                                TAMBIÉN QUE EN SUS FOTOS APAREZCAN POR LO GENERAL POCAS PERSONAS. SUS TOMAS SON EN DIAGONAL, BUSCANDO 
                                SEGUIR LAS LÍNEAS DEL FERROCARRIL, DE LOS TRANVÍAS, DE LOS ÁRBOLES… SUS ENCUADRES NO QUIEREN ROMPER LA 
                                ARMONÍA SINO PRESERVARLA, ASIMILARLA… SUS PLANOS PANORÁMICOS —QUE LE SIRVEN LUEGO PARA ACERCARSE A SUS 
                                TOMAS EN DIAGONAL, OTORGAN PROFUNDIDAD Y AMPLITUD Y REMITEN A UNA SOCIEDAD EN LA QUE PREDOMINA EL 
                                PENSAMIENTO POSITIVISTA, AQUEL QUE PREGONA LA RAZÓN Y LA OBJETIVIDAD COMO PILARES FUNDAMENTALES DEL 
                                PENSAMIENTO CIENTÍFICO». <br><br><br>
                                <p class="text-left">(Un documento histórico: la fotografía en el Perú (1895-1919). Liliana Peñaherrera. 1983)  </p>
                                
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-3">
                        <p style="line-height: 300%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            CUZCO
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-003.png">
                    </div>
                    <div class="col-sm-3"></div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-004.png">
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-037.png">
                        </a>
                        <p class="text-center fontMS100Italic font-15">
                            <br>
                            Cuzco. Tipos de naturales del país. No. 366. Página 160.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <p class="text-justify fontMS500 font-24">
                        <br>
                        COMO SEÑALAN MAJLUF Y WUFFARDEN, «COMO NINGÚN OTRO FOTÓGRAFO DE SU ÉPOCA, 
                        GARREAUD LOGRÓ FORMULAR LOS ÍCONOS MÁS RECONOCIBLES DEL PERÚ ARQUEOLÓGICO. A 
                        PARTIR DE SU TRABAJO, OLLANTAYTAMBO, SACSAHUAMAN, PISAC Y MUCHOS OTROS PUNTOS 
                        SERÍAN FÁCILES DE IDENTIFICAR PARA EL GRAN PÚBLICO. LA POPULARIDAD DE LAS IMÁGENES 
                        DE GARREAUD REFLEJABA TAMBIÉN LOS AVANCES CIENTÍFICOS ALCANZADOS PARALELA-MENTE POR LA ARQUEOLOGÍA Y LA ANTROPOLOGÍA» 
                        <br><br>
                    </p>
                </div>

                <div class="row">
                    <div class="col-sm-6" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-038.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 "  >
                            <br>
                            Cuzco. Interior de la Iglesia de la Compañía. No. 361. Página 158. 
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color:#000000">Biblioteca Digital</a>            
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-039.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Vista general del Cuzco. No. 340. 
                            Página 152.               
                            <br><br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-041.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Vista de Sacsahuáman tomada 
                            del noreste. No. 344. Página 152.              
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-040.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Vista general de la fortaleza de 
                            Ollantaytambo. No. 334. Página 144.
                            <br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-042.png">
                        </a>
                        
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Palacio de Manco Cápac. No. 
                            346. Página 154.
                            <br><br>
                        </p>
                    </div>
                    
                </div>

                <div class="row ">
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-043.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Palacio de Huaina [sic] Cápac. 
                            No. 348. Página 154.               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-044.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Restos del Templo del Sol. No. 
                            351. Página 154.               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-045.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Vista exterior de la Catedral. 
                            No. 362. Página 159.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-046.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Mercado. No. 363. Página 160.              
                            <br><br><br>
                        </p>
                    </div>
                </div>
                



            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                LA ELABORACIÓN DEL ÁLBUM REPÚBLICA PERUANA 1900 MARCA EL ESFUERZO MÁS DESTACADO LLEVADO A CABO POR EL 
                                ESTADO PERUANO A FIN DE CONSOLIDAR SU PROPIA NARRATIVA VISUAL (…), FRENTE A LA URGENTE NECESIDAD DE 
                                INTEGRAR AL TERRITORIO Y POBLACIÓN DEL INTERIOR DENTRO DE LOS IMAGINARIOS NACIONALES CONSTRUIDOS Y 
                                PROYECTADOS DESDE LA PERSPECTIVA MODERNIZADORA Y REGENERACIONISTA DE LA ÉLITE INTELECTUAL Y POLÍTICA 
                                LIMEÑA, QUE TERMINÓ CONSOLIDÁNDOSE EN EL CONTROL DEL ESTADO EN LAS PRIMERAS DÉCADAS DEL SIGLO XX. <br><br>
                                <p class="text-left">(«Bosque, fotografía y exposición. La construcción visual de la Amazonía a través de los clichés de Charles Kroehle y el álbum 
                                    República peruana 1900». Juan Carlos La Serna. 2018) </p>
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <p style="line-height: 500%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-35">
                            MOQUEGUA, TACNA Y ARICA
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-003.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-004.png">
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-057.png">
                        </a>
                        
                        <p class="text-center fontMS100Italic font-15">
                            <br>
                            Vista general de Tarata. No. 370. Página 162.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                    <p class="text-justify fontMS500 font-24">
                        <br>
                        EN ESTE RECORRIDO SE PUEDE APRECIAR VISTAS GENERALES DE TARATA, MOQUEGUA, ILO Y 
                        ARICA. LA VISITA A ESTA ÚLTIMA CIUDAD SE DIO EN EL CONTEXTO DE LA SUSCRIPCIÓN DEL 
                        PROTOCOLO BILLINGHURST-LA TORRE Y EL ARBITRAJE ESPAÑOL DE 1898, REFERIDOS A LA 
                        CUESTIÓN DE TACNA Y ARICA. 
                        <br><br>
                    </p>
                </div>

                <div class="row">
                    <div class="col-sm-6" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-047.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 "  >
                            <br>
                            Cuzco. Interior de la Iglesia de la Compañía. No. 361. Página 158. 
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #000000;">Biblioteca Digital</a>            
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-048.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Vista general del Cuzco. No. 340. 
                            Página 152.               
                            <br><br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-050.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Vista de Sacsahuáman tomada 
                            del noreste. No. 344. Página 152.              
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">   
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-049.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Vista general de la fortaleza de 
                            Ollantaytambo. No. 334. Página 144.
                            <br><br>
                        </p>
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-051.png">
                        </a>
                        <p class="text-center fontMS100Italic font-12 text-white" style="background-color: rgb(0 0 0 / 63%)" >
                            <br>
                            Cuzco. Palacio de Manco Cápac. No. 
                            346. Página 154.
                            <br><br>
                        </p>
                    </div>
                    
                </div>
                



            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-3">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                </div>
                <div class="col-sm-4">
                    <p style="line-height: 120%;margin-bottom: 0%;"
                        class="fontMS700 text-center colorPrincipal  font-35">
                        LA VIGENCIA DEL<br>
                        ESTUDIO GARREAUD
                    </p>
                </div>
                <div class="col-sm-3">
                    <img class="LineSubsec bottom_cel" width="100%"
                        src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
                </div>
                <div class="col-sm-1"></div>
            </div>
            <div class="c100">
                <img class="lineCel" style="margin-top: 0%;" width="100%"
                    src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-000.png">
            </div>

            <div class="row">
                <p class="text-justify fontMS500 font-24 text-white">
                    <br><br>
                    A INICIOS DEL SIGLO XX EL ESTUDIO GARREAUD ERA UNO DE LOS MÁS ACTIVOS DE LIMA. EN 
                    1902, EXPUSO ALGUNAS FOTOGRAFÍAS DEL VIAJE DEL ESTADO MAYOR DEL EJÉRCITO POR 
                    TODO EL PAÍS, PUBLICADAS EN EL REPORTE DE PAUL CLÉMENT. 
                    <br>
                </p>
                <p class="text-justify fontMS100 font-24 text-white">
                    <br>
                    En los años posteriores se publicaron diversas obras ilustradas con imágenes realizadas por F. 
                    Garreaud, tal como las mostramos en esta sección.
                    <br><br>
                </p>
            </div>
            <div class="row">
                <div class="col">
                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-052.png">
                        
                        <p class="text-justify fontMS100Italic font-12 text-white" >
                            <br>
                            Censo de la Provincia Constitucional del 
                            Callao, 20 de junio de 1905 : decretado y 
                            Lima : Impr. y Libr. de San Pedro, 1906. -- 
                            241 p., [37] h. de láms. : il. (principalmentes 
                            col.), diagrs., planos ; 30 cm.            
                            <br><br><br>
                        </p>
                </div>

                <div class="col text-right">
                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-058.png">
                        
                        <p class="text-right fontMS100Italic font-12 text-white"  >
                            <br>
                            Reseña económica del Perú / por Carlos B. Cisneros. – Lima: Impr. La Industria, 1906. – vi, iii, 284 (alg. pleg.), [24] h. de 
                            láms. : il. (alg. color), mapa ; 25 cm           
                            <br><br><br>
                        </p>
                </div>

                <div class="col text-right">
                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-055.png">
                        
                        <p class="text-right fontMS100Italic font-12 text-white"  >
                            <br>
                            L'Italia al Perú : rassegna della vita 
                            dell'opera italiana del Perú. -- Lima : Lit. e 
                            Tip. C. Fabbri, 1905-06. -- 228 p. : il., láms. 
                            ; 33 cm.
                            Antes del título: Esposizione 
                            internazionale di Milano.            
                            <br><br><br>
                        </p>
                </div>

                <div class="col-sm-4 text-right">
                    <img width="100%" src="/assets/images/micrositio/micrositio34/FERNANDOG-056.png">
                        
                        <p class="text-right fontMS100Italic font-12 text-white"  >
                            <br>
                            Autorretrato: Perú 1850-1900 / Guillermo Thorndike ; [reproducciones 
                            fotográficas, Jesús Ruiz Durand y Teddy Loo]. – 1a ed. – Lima: 
                            Promoinvest, Cía. de Inversiones, 1979. – 164 p. : il., retrs. 26 x 27 cm.            
                            <br><br><br>
                        </p>
                </div>
            </div>
        </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-001.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-justify fontMS500 font-18" style="color: #7c7b7b;">
                            <br>
                            <span>
                                <br><br>
                                «ADEMÁS DE GARREAUD Y [ENRIQUE] ARNÁEZ SE TIENE NOTICIAS DE OTROS FOTÓGRAFOS VIAJEROS QUE SE INTERNARON 
                                EN NUESTRO TERRITORIO: CHARLES KROEHLE SIGUIÓ LA RUTA DEL PICHIS MURIENDO DE UNA HERIDA DE FLECHA (ALGUNAS 
                                DE LAS FOTOS FIRMADAS POR GARREAUD PERTENECEN EN REALIDAD A KROEHLE), CHARLES LUMMIS, BANDELIER, CHESTER, 
                                STENNING (QUIENES ILUSTRARON EL RECORRIDO DEL FERROCARRIL DEL CALLAO A LA OROYA)». <br><br><br>
                                («Historia de la fotografía en el Perú». Liliana Peñaherrera. 1988) 
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            El álbum República peruana 1900 
                            testimonia una representación del 
                            Perú como una nación 
                            enrumbada hacia el progreso. 
                            Según las fotografías, ¿cómo 
                            definiría el proceso?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿Cuál de las fotos presentadas le 
                            ha impresionado más? ¿Por qué?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿Cuál es la importancia de la 
                            existencia y difusión de los 
                            archivos fotográficos en la 
                            construcción de la memoria 
                            colectiva?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Fundación Telefónica (2001). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">La recuperación de la 
                                memoria. El primer siglo de la fotografía. Perú 
                                1842-1942. Natalia Majluf, Luis Eduardo Wuffarden 
                                (eds.). 2 tomos. Lima: Museo de Arte de Lima, 
                                Fundación Telefónica.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Majluf, N. y Wuffarden, L. E. (2001). </span>
                            <span class="fontMS100Italic text-gris">El primer siglo de 
                                la fotografía. Perú 1842-1942. En: La recuperación de 
                                la memoria. El primer siglo de la fotografía. Perú 
                                1842-1942. Natalia Majluf, Luis Eduardo Wuffarden 
                                (eds.). Tomo I. Lima: Museo de Arte de Lima, 
                                Fundación Telefónica, p. 20-133. </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Mori, J. (2017). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Álbum república peruana 1900: de 
                                Fernando Garreaud (índice, estudio y notas). Boletín 
                                de la Biblioteca Nacional. p. 211-279 : retrs.<br></span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Mori, J. (1999). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Archivos fotográficos de la Biblioteca 
                                Nacional del Perú. Fénix: revista de la Biblioteca 
                                Nacional. No. 40-41, p. 145-162 ; retrs. 
                                Disponible en: 
                                <a style="color: #000000;" href="https://revistafenix.bnp.gob.pe/index.php/fenix/articl" target="_blank">http://hdl.handle.net/20.500.14428/78954</a>
                                <br></span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Peñaherrera Sánchez, L. (1983). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Un documento 
                                histórico: la fotografía en el Perú (1895-1919). 
                                Memoria para optar el grado de Bachiller en Historia. 
                                Lima: Pontificia Universidad Católica del Perú, 
                                Facultad de Letras y Ciencias Humanas.
                                <br></span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">La Serna Salcedo, J. C. (2018). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Bosque, fotografía y 
                                exposición. La construcción visual de la Amazonía a 
                                través de los clichés de Charles Kroehle y el álbum 
                                República peruana 1900. Entre líneas. Año I, no. 2, p. 
                                41-55.
                                Disponible en: <br>
                                <a style="color: #000000;" href="https://revistas.ulima.edu.pe/index.php/enlineasgen
                                erales/article/view/2666" target="_blank">https://revistas.ulima.edu.pe/index.php/enlineasgen
                                erales/article/view/2666</a>
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Majluf, N. y Wuffarden, L. E. (2001). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Índice 
                                documentado de fotógrafos activos en el Perú 
                                1842-1942. En: La recuperación de la memoria. El 
                                primer siglo de la fotografía. Perú 1842-1942. Natalia 
                                Majluf, Luis Eduardo Wuffarden (eds.). Tomo II. Lima: 
                                Museo de Arte de Lima, Fundación Telefónica, p. 
                                36-103.  <br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Peñaherrera Sánchez, L. (1988). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Historia de la 
                                fotografía en el Perú. Lienzo: revista de la Universidad 
                                de Lima. No. 8, p. 235-[248] : retrs. 
                                Disponible   <br>
                                <a style="color: #000000;" href="https://revistas.ulima.edu.pe/index.php/lienzo/articl
                                e/view/3967/3856" target="_blank">https://revistas.ulima.edu.pe/index.php/lienzo/articl
                                e/view/3967/3856</a>
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>